import { render, staticRenderFns } from "./SSMerchandiseForm.vue?vue&type=template&id=0912f83b&"
import script from "./SSMerchandiseForm.vue?vue&type=script&lang=js&"
export * from "./SSMerchandiseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SSMerchandiseForm.vue"
export default component.exports